
(function () {
  if (!window.performance || !performance.navigation) return;

  // Capture the real values BEFORE we override anything.
  var realLegacyType = performance.navigation.type;
  var navEntry = (performance.getEntriesByType('navigation') || [])[0];
  var realModernType = navEntry ? navEntry.type : 'navigate';

  function calledByInkybay() {
    try { return (new Error().stack || '').indexOf('inkybay') !== -1; }
    catch (e) { return false; }
  }

  try {
    Object.defineProperty(performance.navigation, 'type', {
      configurable: true,
      get: function () {
        return calledByInkybay() ? 0 : realLegacyType;
      }
    });
  } catch (e) {}

 
  var origGetEntries = performance.getEntriesByType.bind(performance);
  performance.getEntriesByType = function (type) {
    var result = origGetEntries(type);
    if (type === 'navigation' && result && result[0] && calledByInkybay()) {
      return [new Proxy(result[0], {
        get: function (target, prop) {
          if (prop === 'type') return 'navigate';
          var value = target[prop];
          return typeof value === 'function' ? value.bind(target) : value;
        }
      })];
    }
    return result;
  };
})();